import {
  handleAddStandardClick,
  handleDismissAlertClick,
  handleAcceptMentorInviteClick
} from "../../lib/gt/alerts";

const $alertTypeSelect = $('#alertType');
const $headerAlert = $('#headerAlert');
const $headerAlertBtn = $('#alertBtn');
const $addStandard = $('.add-standard');
const $dismissAlert = $('.dismiss-alert');
const $acceptMentorInvite = $('.accept-mentor-invite');
let alertsCount = $("#alertsCount").data("alerts-count");

$alertTypeSelect.selectize();

$(document).click(e => {
  if ($headerAlertBtn.has(e.target).length > 0) {
    return $headerAlert.toggleClass('d-none');
  }

  if (!$headerAlert.is(e.target) && $headerAlert.has(e.target).length === 0) {
    $headerAlert.addClass('d-none');
  }
});

$dismissAlert.click((e) => {
  e.preventDefault();

  const self = $(e.currentTarget);
  const alertId = self.data('alert-id');

  alertsCount--;
  $.get("index.php/goaltab3/alerts/mark_as_read/" + alertId, handleDismissAlertClick(self, alertsCount));
});

$addStandard.click((e) => {
  e.preventDefault();

  const self = $(e.currentTarget);
  const standardId = self.data('standard-id');
  const alertId = self.data('alert-id');

  alertsCount--;
  $.get("index.php/goaltab3/standards/add_standard/" + standardId, handleAddStandardClick(self, alertId, alertsCount));
});

$acceptMentorInvite.click((e) => {
  e.preventDefault();

  const self = $(e.currentTarget);

  const standard_id = self.data('standard-id');
  const mentee_id = self.data('mentee-id');
  const alertId = self.data('alert-id');

  const url = "index.php/goaltab3/mentors/accept_invite/" + standard_id + "/" + mentee_id;

  alertsCount--;
  $.get(url, handleAcceptMentorInviteClick(self, alertId, alertsCount));
});
